<template>
  <div class="vouchers__history">
    <div class="row align-items-center __content_list"
      v-if="isLoading">
      <half-circle-spinner
        :animation-duration="1500"
        :size="50"
        color="#1D3354"
        class="mx-auto"
      />
    </div>
    <div v-else class="">
      <div v-if="!redeemHistory || items.length === 0"
           class="global__nodata">
        <div class="text-center">
          <img src="@/assets/image/icon/nodata-point.svg" alt="">
          <h6 class="pt-3">There is No History Redeem</h6>
        </div>
      </div>
      <div v-else class="tables__andalinpoint">
        <b-table
          sticky-header="true"
          responsive
          :items="items"
          :fields="fields"
        >
          <template v-slot:head()="scope">
            <div class="text-nowrap table__label">
              <div class="text-nowrap"> {{ scope.label }} </div>
            </div>
          </template>
          <template #table-colgroup="scope">
            <col
              v-for="field in scope.fields"
              :key="field.key"
              :style="{ width: field.label === 'Voucher Type'
                        || field.label === 'Other Remark' ? '32%' : '' }"
            >
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import { HalfCircleSpinner } from 'epic-spinners'
import { mapGetters } from 'vuex'
import * as moment from 'moment'

export default {
  components: {
    HalfCircleSpinner
  },
  data () {
    return {
      fields: [
        'Voucher_Type',
        'Redeem_Time',
        'Status',
        'Other_Remark'
      ],
      items: []
    }
  },
  computed: {
    ...mapGetters({
      redeemHistory: 'andalinpoint/pointVoucher',
      isLoading: 'andalinpoint/isLoadingpointVoucher',
      isError: 'andalinpoint/isLoadingpointVoucher',

      redeemPoint: 'andalinpoint/redeemPoint',
      isLoadingredeemPoint: 'andalinpoint/isLoadingredeemPoint',
      errorredeemPoint: 'andalinpoint/errorredeemPoint'
    })
  },
  mounted () {
    this.fetchVoucherHistory()
  },
  methods: {
    async fetchVoucherHistory () {
      await this.$store.dispatch('andalinpoint/FETCH_POINT_VOUCHER')
      this.getItems()
    },
    getItems () {
      return new Promise((resolve) => {
        this.items = []
        if (this.redeemHistory) {
          this.redeemHistory.forEach((item) => {
            item.history.forEach((history) => {
              const newItem = {
                Voucher_Type: history.point_type,
                Redeem_Time: this.getDate(item.date),
                Status: this.statusRedeem(history.status),
                Other_Remark: history.remarks
              }
              this.items.push(newItem)
            })
          })
          return resolve()
        }
      })
    },
    statusRedeem (type) {
      if (type === 0) {
        return 'Submitted ' // processing on internal
      } else if (type === 1) {
        return 'Received' // done on internal
      }
      return '-'
    },
    getDate (date) {
      return moment(new Date(date)).format('DD MMMM YYYY')
    }
  },
  watch: {
    redeemPoint (data) {
      if (data) {
        this.fetchVoucherHistory()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/andalinpoint/points/RedeemHistory.vue